
import * as endpoints from '~/api/endpoints'
import WCollapsible from '~/components/global/w-collapsible/w-collapsible.vue'
import WReturn from '~/components/global/w-return/w-return.vue'
import { types as itemTypes } from '~/utils/product-item-type'

let roiAbortController
let transactionFeeAbortController

export default {
  components: {
    WCollapsible,
    WReturn,
  },
  props: {
    itemId: {
      type: Number,
      default: 1,
    },
    orderDetails: {
      type: Array,
      default: () => [],
    },
    showRoi: {
      type: Boolean,
      default: false,
    },
    roiDirectSell: {
      type: Boolean,
      default: false,
    },
    subtractTransactionFee: {
      type: Boolean,
      default: false,
    },
    transactionFeeIsDefinite: {
      type: Boolean,
      default: false,
    },
    itemType: {
      type: String,
      default: itemTypes.Bottle,
      validator: (v) => Object.values(itemTypes).includes(v),
    },
  },

  data() {
    return {
      showDetails: false,
      roi: 0,
      transactionFee: 0,
    }
  },

  computed: {
    orderTotal() {
      return this.orderDetails.reduce(
        (total, { subTotal }) => total + subTotal,
        0,
      )
    },

    quantityTotal() {
      return this.orderDetails.reduce(
        (total, { quantity }) => total + quantity,
        0,
      )
    },

    roiIsCalculated() {
      return this.roi !== 0
    },

    collapsibleLabel() {
      return this.showDetails
        ? this.$gettext('Close details')
        : this.$gettext('Open details')
    },

    transactionFeeLabelkey() {
      return this.transactionFeeIsDefinite
        ? 'Transaction fee'
        : 'Expected transaction fee'
    },
  },

  watch: {
    orderDetails() {
      this.getExpectedTransactionCost()

      if (this.showRoi) {
        this.getRoi()
      }
    },
  },

  created() {
    this.getExpectedTransactionCost()

    if (this.showRoi) {
      this.getRoi()
    }
  },

  methods: {
    toggleDetails() {
      this.showDetails = !this.showDetails
    },

    async getRoi() {
      const {
        orderDetails: [{ price }],
        itemId,
        roiDirectSell,
        quantityTotal,
      } = this

      const requestData = {
        itemId,
        price: roiDirectSell ? null : price,
        quantity: quantityTotal,
      }

      if (roiAbortController) {
        roiAbortController.abort()
      }

      roiAbortController = new AbortController()

      try {
        const { data } = await this.$axios.post(
          endpoints.calculateSellRoi,
          requestData,
          {
            signal: roiAbortController.signal,
          },
        )
        this.roi = data.roi
      } catch (error) {
        console.error('Unable to get calculated ROI', error)
      }
    },

    async getExpectedTransactionCost() {
      if (transactionFeeAbortController) {
        transactionFeeAbortController.abort()
      }

      transactionFeeAbortController = new AbortController()

      try {
        const {
          data: { transactionFee },
        } = await this.$axios.post(
          endpoints.getExpectedTransactionCost(this.itemType),
          {
            value: this.orderTotal,
          },
          {
            signal: transactionFeeAbortController.signal,
          },
        )
        this.transactionFee = transactionFee

        this.$emit('transaction-fee:change', transactionFee)
      } catch (error) {
        console.error('Unable to get expected transaction fee', error)
      }
    },
  },
}
